import { memo } from 'react';
import { Typography } from '@mui/material';

import ProductCard from './productCard';
import { ProductCard as ProductCardProps, ProductsCategoryProps } from '../interfaces';

interface Props extends ProductsCategoryProps {
  className: string;
}

const ProductsCategory = ({ className, products, title: categoryTitle }: Props) => (
  <>
    <Typography className={className} variant="h2">
      {categoryTitle}
    </Typography>
    {products.map(({ description, icon, title, api, isActive }: ProductCardProps, index) => (
      <ProductCard key={index} isActive={isActive} description={description} icon={icon} title={title} api={api} />
    ))}
  </>
);
export default memo(ProductsCategory);
